import pkg from '../../package.json'
export const config = {
  env: process.env.VUE_APP_SERVER_ENV,
  applicationId: process.env.VUE_APP_DD_applicationId,
  clientToken: process.env.VUE_APP_DD_clientToken,
  dd_env: process.env.DD_ENV,
  version: pkg.version,
}
